import styled from '@emotion/styled'

export const V2L1AppHeaderTitle = styled.div(({theme}) => ({
	...theme.fonts.titleBold,
	fontSize: `${20/16}rem`,
}))

export const V2L1AppHeaderSpacer = styled.div({
	flex: '1 1 auto',
})
